<mat-form-field 
      appearance="outline" 
      color="primary" 
      class="autocomplete" 
      subscriptSizing="dynamic" 
      [class]="field.className"
      
  >
   <div class="flex items-center">
      <lib-app-icon icon="search_icon" matPrefix size="24x24" className="text-[#41484D]" /> 
      <input 
          #input
          matInput
          type="text"
          [id]="field.key"
          [name]="field.key"
          [matAutocomplete]="auto"
          (input)="this.onInputChange()"
          class="input-autocomplete"
          [placeholder]="field.placeholder"
      />
      @if(this.shouldShowLoadingSpinner()) { 
        <mat-spinner diameter="24" class="pb-[6px]"></mat-spinner>
      }
   </div>
    <div class="selected-section">
      @for(option of this.selectedOptions; track option.value) {
        <div class="dropdown-item selected" >
          {{option.viewValue}}
          <button mat-icon-button  (click)="$event.stopPropagation()" (click)="removeSelectedOption(option)">
            <lib-app-icon icon="delete_icon" size="16x16" />
          </button>
        </div>
      }
    </div>
    <mat-divider></mat-divider>  
    <mat-autocomplete class="autocomplete" #auto="matAutocomplete" [displayWith]="displayWith" autoActiveFirstOption
        (opened)="this.handleOnAutocompleteOpen()">
        @for (option of options; track option) {
            <mat-option [value]="option" (click)="addSelectedOption(option)"  >
              <span [appHighlightText]="option.viewValue" [highlightTerm]="this.input.nativeElement.value" class="multiline-ellipsis"></span>
            </mat-option>
        }
    </mat-autocomplete>
  @if(field.icon) {
      <lib-app-icon [icon]="field.icon" matSuffix size="48x48" className="p-[12px]" />
  }
  </mat-form-field>